import "./i18n/i18n";

import { store } from "./store/store";

import { Box, CircularProgress, CssBaseline } from "@mui/material";
import { GlobalContextProvider } from "./context";
import { Provider } from "react-redux";
import RTL from "./mui/rtl/RTL";
import RouteElements from "./navigation";
import { ToastContainer } from "./components/shared/toaster";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { getThemeConfig } from "./lib/GetThemeConfog";
import { Dictionary, Theme } from "./types/theme";
import { ThemeConfigProvider } from "./context/theme";
import { MuiThemeConfigProvider } from "./context/theme/muiThemeProvider";
import { updateTranslations } from "./i18n/i18n";
import CheckUserToken from "./components/pages/wait-fetch-profile/check-user-token";
import AnalyticsScripts from "./AnalyticsScripts";
import { logger } from "./utils";

// update common - routes - translation
function I18nUpdater({
  children,
  dictionary,
}: {
  children: React.ReactNode;
  dictionary: Dictionary;
}) {
  useEffect(() => {
    if (dictionary) {
      updateTranslations(dictionary);
    }
  }, [dictionary]);
  return <>{children}</>;
}

function App() {
  const [ProjectTheme, setProjectTheme] = useState<Theme>(null);

  useEffect(() => {
    getThemeConfig().then((theme) => {
      setProjectTheme(theme);
    });
  }, []);

  const analyticsConfig = ProjectTheme?.config?.metaTags;

  // if theme config not found !
  if (!ProjectTheme) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  logger.info('logger is on')

  return (
    <>
      {analyticsConfig && (
        <AnalyticsScripts
          googleTag={analyticsConfig.googleTag}
          analyticsTag={analyticsConfig.analyticsTag}
          ga4Tag={analyticsConfig.ga4Tag}
          yektanetTag={analyticsConfig.yektanetTag}
          clarity={analyticsConfig.clarity}
          rybbit={analyticsConfig.rybbit}
        />
      )}

        <ThemeConfigProvider initialTheme={ProjectTheme}>
          <I18nUpdater dictionary={ProjectTheme?.dictionary}>
            <Provider store={store}>
              <RTL>
                <MuiThemeConfigProvider
                  initialPrimary={ProjectTheme?.config?.muiThemeConfig?.primary}
                >
                  <CheckUserToken>
                    <CssBaseline />
                    <GlobalContextProvider>
                      <RouteElements />
                      <ToastContainer />
                    </GlobalContextProvider>
                  </CheckUserToken>
                </MuiThemeConfigProvider>
              </RTL>
            </Provider>
          </I18nUpdater>
        </ThemeConfigProvider>
    </>
  );
}

export default App;
